// removed by extract-text-webpack-plugin
module.exports = {"submitButton":"Style__submitButton___3herQ","component":"Style__component___3QkE0","recaptcha":"Style__recaptcha___3c4yd"};


//////////////////
// WEBPACK FOOTER
// ./client/components/Login/Client/Style.css
// module id = 2014
// module chunks = 0